import * as React from 'react';
import { headingSectionIllustrationPositionContext } from './context';
export function useHeadingSectionIllustrationPosition() {
    var headingSectionIllustrationPosition = React.useContext(headingSectionIllustrationPositionContext);
    return headingSectionIllustrationPosition;
}
